import Vue from 'vue'
import App from '@/App.vue'

// api
import '@/shared/services/api'

// store
import store from '@/shared/store'

// pinia
import pinia from './pinia'

// router
import router from './router'

// plugins
import '@/shared/plugins'

// layout AdminLTE
import './shared/layouts/adminlte'

// filters
import '@/shared/common/filters'

import '@/shared/assets/css/main.scss'

// Configurações do módulo
Vue.prototype.$urlBase = '/emissor'

new Vue({
    router,
    store,
    pinia,
    render: h => h(App)
}).$mount('#app')
